import React, { useContext } from 'react';
import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import StarRatingComponent from 'react-star-rating-component';

import Box from '../../../elements/Box';
import Icon from '../../../elements/Icon';

const FareItemRating = (props) => {
  const { starRatingStyle, rating } = props;

  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  return (
    <Box display="flex" flexDirection="row" className={className} style={style}>
      <StarRatingComponent
        editing={false}
        name="rate1"
        starCount={5}
        value={parseFloat(rating)}
        renderStarIcon={(index, value) => {
          return (
            <Icon
              icon="star-full"
              className={index <= value ? 'fr-star-full' : 'fr-star-empty'}
              iconColor={index <= value ? 'secondary' : 'dark'}
              size={14}
              {...starRatingStyle}
            />
          );
        }}
        renderStarIconHalf={() => {
          return <Icon icon="star-half" iconColor="white" size={14} {...starRatingStyle} />;
        }}
      />
    </Box>
  );
};

FareItemRating.componentName = 'FareItemRating';

export default FareItemRating;
